module.exports = __webpack_public_path__ + "img/블랙발큐리아.0de37b8e.png";